import { setTerminalConfig } from "@jidlomat/terminal-core/config/terminalConfig";
import { createTerminalConfig } from "./terminalConfig";

// Imported for its side effect, as the FIRST import of main.tsx: modules are evaluated in import
// order, so the config is in place before any other module of the app runs.
setTerminalConfig(createTerminalConfig());
